module.exports = __webpack_public_path__ + "static/img/4669_phase_function_Paper_Points.34ab606.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4669_phase_function_Paper_Points.png
// module id = hMJ/
// module chunks = 0